import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/gift.svg'
import _imports_1 from '../assets/omzet.svg'


const _hoisted_1 = {
  class: "p-3 rounded-2xl bg-white z-10",
  style: {"height":"183px"}
}
const _hoisted_2 = { class: "flex flex-col justify-between h-full" }
const _hoisted_3 = { class: "flex items-start justify-between" }
const _hoisted_4 = { class: "w-2/3 flex flex-col" }
const _hoisted_5 = { class: "flex gap-x-1.5" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "gift",
  class: "w-4"
}, null, -1)
const _hoisted_7 = { class: "text-gray-lp-800 font-semibold text-base" }
const _hoisted_8 = {
  class: "text-black-lp-100 font-bold leading-10",
  style: {"font-size":"40px"}
}
const _hoisted_9 = { class: "w-1/3 flex flex-col" }
const _hoisted_10 = { class: "flex items-center gap-x-1.5" }
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "omzet",
  class: "w-4"
}, null, -1)
const _hoisted_12 = { class: "text-gray-lp-800 font-semibold text-base" }
const _hoisted_13 = { class: "relative" }
const _hoisted_14 = { class: "w-full flex flex-col text-12px font-montserrat py-2 font-normal" }
const _hoisted_15 = { class: "text-black-lp-100 font-bold text-2xl" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_SliderLeaderboard = _resolveComponent("SliderLeaderboard")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('dashboard.leaderboard.cardReward.totalEstimatedReward')), 1)
          ]),
          _createVNode("span", _hoisted_8, _toDisplayString(_ctx.formatPriceRP(_ctx.data.totals.totalEstimatedReward)), 1)
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('dashboard.leaderboard.cardReward.totalRevenue')), 1),
            _createVNode("div", _hoisted_13, [
              _createVNode("button", {
                onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleTooltip($event))),
                onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleTooltip($event)))
              }, [
                _createVNode(_component_Icons, {
                  name: "info",
                  class: ["ml-1 h-4 xxl:h-5 cursor-pointer", [
                    _ctx.isActiveTooltip ? 'text-red-lp-100' : 'text-black-lp-100'
                  ]],
                  alt: "info"
                }, null, 8, ["class"])
              ], 32),
              _createVNode(_component_OverlayPanel, {
                ref: "opTooltip",
                appendTo: "body",
                class: "w-1/4 bg-white text-black-lp-300"
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('dashboard.leaderboard.cardReward.tooltip.revenueInfo')), 1)
                ]),
                _: 1
              }, 512)
            ])
          ]),
          _createVNode("span", _hoisted_15, _toDisplayString(_ctx.formatPriceRP(_ctx.data.totals.totalRevenue)), 1)
        ])
      ]),
      _createVNode(_component_SliderLeaderboard, {
        "card-data": _ctx.data.cards
      }, null, 8, ["card-data"])
    ])
  ]))
}